<template>
  <el-form-item :label="i18nt('designer.setting.widgetSize')">
    <el-select v-model="optionModel.size" clearable>
      <el-option v-for="item in widgetSizes" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { toRefs, reactive } from 'vue';
import { useI18n } from '@/utils/i18n';

export default {
  name: 'm-button-size-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const widgetSizes = reactive([
      { label: 'normal', value: 'normal' },
      { label: 'large', value: 'large' },
      { label: 'small', value: 'small' },
      { label: 'mini', value: 'mini' },
    ]);

    return {
      i18nt,
      ...toRefs(props),
      widgetSizes,
    };
  },
};
</script>

<style scoped></style>
